import "./CustomerCare.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiries from "./sections/Inquiries";
import Assistance from "./sections/Assistance";
import Footer from "@/reusable_sections/Footer";
export default function CustomerCarePage() {
  return <div>
      <Navigation />
      <Inquiries />
      <Assistance />
      <Footer />
    </div>;
}